// @flow
import * as React from 'react';
import styles from './Divider.css';

export default function Divider() {
  return <hr className={styles.divider} />;
}
